import { render, staticRenderFns } from "./PopupAIRiskReductions.vue?vue&type=template&id=d3e237b0&scoped=true"
import script from "./PopupAIRiskReductions.vue?vue&type=script&lang=js"
export * from "./PopupAIRiskReductions.vue?vue&type=script&lang=js"
import style0 from "./PopupAIRiskReductions.vue?vue&type=style&index=0&id=d3e237b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e237b0",
  null
  
)

export default component.exports